// extracted by mini-css-extract-plugin
export default {"form":"styles_form__wG4sb","single":"styles_single__6Q-XK","textarea":"styles_textarea__6ZkDw","button":"styles_button__1rWj0","latir":"styles_latir__wDfZE"};